function addAplusInfo () {
  if (!__isBrowser__) {
    return
  }
  const q = (window.goldlog_queue || (window.goldlog_queue = []))
  q.push({
    action: 'goldlog.setMetaInfo',
    arguments: ['aplus-auto-exp-userfn', function (element) {
      if (element) {
        return {
          scm: element.getAttribute('data-scm') || '',
          userdata: {}
        }
      }
    }]
  })
  q.push({
    action: 'goldlog.setMetaInfo',
    arguments: ['aplus-auto-clk-userfn', function (element) {
      if (element) {
        return {
          scm: element.getAttribute('data-scm') || '',
          userdata: {}
        }
      }
    }]
  })
}
export default addAplusInfo()
